import React, { JSX } from 'react'
import './index.scss'
import { RowComponent } from './RowComponent'

export type JourneyProps = {
  content: any
}

export const Journey = ({ content }: JourneyProps): JSX.Element => {
  return (
    <div className='JourneysComponent u-sizeConstrained u-md-paddingHoriz8gu'>
      <div className='Journey u-flex u-paddingBottom8gu u-posRelative u-sizeFull u-lg-size6of12 u-lg-before6of12'>
        <i className='Journey-step-start u-flex u-flexJustifyCenter u-flexAlignItemsCenter u-sizeFull'></i>
      </div>
      {content.milestone.milestones.map((item: any) => (
        <RowComponent
          contentDesc={item.textContent}
          milestoneColor={item.bgcolor}
          milestoneMonthDesc={item.label}
          key={item.label}
          leftAligned={item.alignment === 'Left Aligned'}
          icon={item.icon}
          image={item.image}
        />
      ))}
    </div>
  )
}
